module.exports = __webpack_public_path__ + "static/img/term_library_creat.9b9acaee.gif";